@if (tools().length) {
  <div class="hr-compare-bar" data-testid="hr-tool-compare-bar">
    <div class="hr-compare-bar__inner">
      <div class="hr-compare-bar__label">
        <i class="pi pi-arrows-h text-button-red"></i>
        <span class="hidden font-semibold sm:inline">
          {{ 'hrTool.comparison.eyebrow' | transloco }} ({{ tools().length }}/{{ maxTools }})
        </span>
      </div>

      <div class="hr-compare-bar__items">
        @for (tool of tools(); track tool.id) {
          <div class="hr-compare-chip" [attr.data-testid]="'compare-bar-chip-' + tool.id">
            @if (tool.coverImage) {
              <img
                [src]="tool.coverImage"
                [alt]="toolName(tool)"
                class="h-5 w-8 object-contain"
                (error)="hideBrokenImage($event)"
              />
            }
            <span class="max-w-32 truncate">{{ toolName(tool) }}</span>
            <button
              type="button"
              class="hr-compare-chip__remove"
              (click)="remove(tool.id)"
              [attr.aria-label]="toolName(tool)"
              [attr.data-testid]="'compare-bar-remove-' + tool.id"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
        @for (slot of emptySlots(); track $index) {
          <div class="hr-compare-slot">{{ 'hrTool.compareBar.emptySlot' | transloco }}</div>
        }
      </div>

      <div class="hr-compare-bar__actions">
        <button
          type="button"
          class="hr-compare-clear"
          (click)="clearAll()"
          data-testid="compare-bar-clear"
        >
          {{ 'hrTool.comparison.button.removeAllTools' | transloco }}
        </button>
        <p-button
          [label]="'hrTool.detail.compare' | transloco"
          severity="danger"
          [disabled]="!canCompare()"
          (onClick)="openCompare()"
          data-testid="compare-bar-open"
        />
      </div>
    </div>
  </div>
}
